import React from 'react';

export const BlackRow = () => <rect y="29" width="370" height="40" fill="#142633" />;

export default BlackRow;
